document.addEventListener('DOMContentLoaded',function(){if(window.innerWidth<=768){document.querySelectorAll('.product-page .product-info .rte').forEach(function(el){if(el.dataset.mobileToggleReady)return;el.dataset.mobileToggleReady='1';if(el.scrollHeight<=150)return;var btn=document.createElement('button');btn.type='button';btn.className='mobile-read-more';btn.textContent='Arata mai mult';el.insertAdjacentElement('afterend',btn);btn.addEventListener('click',function(){var open=el.classList.toggle('is-open');btn.textContent=open?'Arata mai putin':'Arata mai mult';});});}});

;
document.addEventListener('DOMContentLoaded', function () {
  var menuBtn = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-menu-panel]');
  var backdrop = document.querySelector('[data-menu-backdrop]');
  var closeBtn = document.querySelector('[data-menu-close]');
  var searchBtn = document.querySelector('[data-search-toggle]');
  var search = document.querySelector('[data-search-panel]');
  var close = document.querySelector('[data-search-close]');

  // The sticky header uses backdrop-filter, which creates a CSS containing
  // block. Portal the overlay and drawer to <body> so they cover and blur
  // the entire viewport, including the header and page content.
  if (menu && backdrop) {
    document.body.appendChild(backdrop);
    document.body.appendChild(menu);
  }

  var menuCloseTimer = null;
  var menuIsOpen = false;

  function setMenuOpen(open, returnFocus) {
    if (!menu || !menuBtn || !backdrop) return;
    if (menuCloseTimer !== null) {
      window.clearTimeout(menuCloseTimer);
      menuCloseTimer = null;
    }
    menuIsOpen = Boolean(open);
    menuBtn.setAttribute('aria-expanded', String(menuIsOpen));
    document.body.classList.toggle('alib-mobile-drawer-open', menuIsOpen);

    if (menuIsOpen) {
      menu.hidden = false;
      backdrop.hidden = false;
      // Force the off-screen starting state before sliding in.
      void menu.offsetWidth;
      menu.classList.add('alib-mobile-drawer--visible');
      backdrop.classList.add('alib-mobile-drawer-backdrop--visible');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    } else {
      menu.classList.remove('alib-mobile-drawer--visible');
      backdrop.classList.remove('alib-mobile-drawer-backdrop--visible');
      if (returnFocus) menuBtn.focus({ preventScroll: true });
      // Keep both elements rendered while their exit transitions play.
      menuCloseTimer = window.setTimeout(function () {
        if (!menuIsOpen) {
          menu.hidden = true;
          backdrop.hidden = true;
        }
        menuCloseTimer = null;
      }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 330);
    }
  }

  if (menuBtn && menu && backdrop) {
    menuBtn.addEventListener('click', function () { setMenuOpen(!menuIsOpen, false); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setMenuOpen(false, true); });
    backdrop.addEventListener('click', function () { setMenuOpen(false, true); });
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a[href]')) setMenuOpen(false, false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menuIsOpen) {
        setMenuOpen(false, true);
      }
      if (event.key === 'Tab' && menuIsOpen) {
        var focusable = Array.from(menu.querySelectorAll('a[href],button:not([disabled])'));
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 800 && menuIsOpen) setMenuOpen(false, false);
    });
  }
  if (searchBtn && search) searchBtn.addEventListener('click', function () {
    setMenuOpen(false, false);
    search.hidden = false;
    setTimeout(function () {
      var input = search.querySelector('input[type=search]');
      if (input) input.focus();
    }, 50);
  });
  if (close && search) close.addEventListener('click', function () { search.hidden = true; });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && search) search.hidden = true;
  });
});

;
(() => {
  const STORAGE = {
    start: 'alib-rental-start',
    end: 'alib-rental-end',
    discount: 'alib-discount-code'
  };

  const root = (() => {
    const value = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return value.endsWith('/') ? value : value + '/';
  })();

  const qs = (selector, parent = document) => parent.querySelector(selector);
  const qsa = (selector, parent = document) => Array.from(parent.querySelectorAll(selector));

  let cartState = null;
  let queue = Promise.resolve();
  let initialized = false;
  window.AliBCart = { whenIdle: () => queue, discountCode: () => readLocal(STORAGE.discount), quoteTotals: () => ({ subtotalCents: currentSubtotal(), discountCents: scaledDiscount(currentSubtotal(), cartState) }) };

  const enqueue = (task) => {
    queue = queue.catch(() => {}).then(task);
    return queue;
  };

  const money = (cents) =>
    `${(Math.max(0, Number(cents || 0)) / 100).toLocaleString('ro-RO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })} €`;

  const readLocal = (key) => {
    try { return localStorage.getItem(key) || ''; } catch (_) { return ''; }
  };

  const writeLocal = (key, value) => {
    try {
      if (value) localStorage.setItem(key, value);
      else localStorage.removeItem(key);
    } catch (_) {}
  };

  async function requestCart(path, options = {}) {
    const response = await fetch(root + path, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        ...(options.body ? { 'Content-Type': 'application/json' } : {}),
        ...(options.headers || {})
      },
      ...options
    });

    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(data.description || data.message || `Eroare coș (${response.status})`);
    }
    return data;
  }

  const fetchCart = () => requestCart('cart.js');

  function updateBadge(count) {
    qsa('[data-cart-items-count]').forEach(el => { el.textContent = count + (Number(count) === 1 ? ' produs' : ' produse'); });
    qsa('[data-cart-count]').forEach((badge) => {
      badge.textContent = String(Number(count || 0));
    });
  }

  function getDates() {
    return {
      start: qs('[data-rental-start]')?.value || '',
      end: qs('[data-rental-end]')?.value || ''
    };
  }

  function saveDatesLocal() {
    const { start, end } = getDates();
    writeLocal(STORAGE.start, start);
    writeLocal(STORAGE.end, end);
    return { start, end };
  }

  function rentalDays() {
    const { start, end } = getDates();
    if (!start || !end) return 1;

    const startDate = new Date(start + 'T00:00:00Z');
    const endDate = new Date(end + 'T00:00:00Z');
    const diff = Math.round((endDate - startDate) / 86400000);
    return Math.max(1, Number.isFinite(diff) ? diff : 1);
  }

  function billableDays(days = rentalDays()) {
    const realDays = Math.max(1, Number(days || 1));
    const fullWeeks = Math.floor(realDays / 7);
    const remainder = realDays % 7;
    return Math.max(1, fullWeeks * 5 + remainder);
  }

  function currentSubtotal() {
    const days = billableDays();
    let subtotal = 0;

    qsa('[data-cart-line]').forEach((line) => {
      const unit = Math.max(0, Number(line.dataset.unitPrice || 0));
      const qty = Math.max(0, Number(qs('[data-cart-qty]', line)?.value || 0));
      const lineTotal = unit * qty * days;
      subtotal += lineTotal;

      const price = qs('[data-line-price]', line);
      if (price) price.textContent = money(lineTotal);
    });

    return subtotal;
  }

  // Shopify may return a discount as a cart-level application, a line-level
  // allocation, or only in the cart's aggregate totals. All are supported.
  function scaledDiscount(subtotal, cart) {
    if (!cart || subtotal <= 0) return 0;
    const days = billableDays();
    const code = String(readLocal(STORAGE.discount) || '').toUpperCase();
    const codes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
    const accepted = codes.some(entry =>
      entry && entry.applicable === true && (!code || String(entry.code || '').toUpperCase() === code)
    );
    let discount = 0;
    let hasDiscountApplication = false;
    const cartApps = cart.cart_level_discount_applications || [];
    const lineApps = (cart.items || []).flatMap(item => item.line_level_discount_allocations || []);

    for (const app of cartApps) {
      if (app?.type !== 'discount_code') continue;
      hasDiscountApplication = true;
      const allocated = Math.max(0, Number(app.total_allocated_amount || 0));
      const percentage = Number(app.value || 0);
      if (app.value_type === 'percentage') {
        discount += percentage > 0 && percentage <= 100
          ? Math.round(subtotal * percentage / 100)
          : Math.round(allocated * days);
      } else {
        discount += allocated;
      }
    }
    for (const allocation of lineApps) {
      const app = allocation.discount_application || {};
      if (app.type !== 'discount_code') continue;
      hasDiscountApplication = true;
      const allocated = Math.max(0, Number(allocation.amount || 0));
      discount += app.value_type === 'percentage'
        ? Math.round(allocated * days)
        : allocated;
    }

    // Some Shopify cart responses expose only the discount application list,
    // without an allocation. Its percentage is still authoritative.
    if (discount === 0) {
      for (const app of (cart.discount_applications || [])) {
        if (app?.type !== 'discount_code') continue;
        if (code && String(app.title || '').toUpperCase() !== code) continue;
        hasDiscountApplication = true;
        const percent = Number(app.value || 0);
        if (app.value_type === 'percentage' && percent > 0 && percent <= 100) {
          discount += Math.round(subtotal * percent / 100);
        }
      }
    }

    // Last-resort fallback for a code Shopify confirms applicable, where
    // discount details are omitted but aggregate cart savings are available.
    if (discount === 0 && accepted) {
      const dailyOriginal = Math.max(0, Number(cart.original_total_price || 0));
      const dailySavings = Math.max(0, Number(cart.total_discount || 0),
        dailyOriginal - Math.max(0, Number(cart.total_price || 0)));
      if (dailyOriginal > 0 && dailySavings > 0) {
        const percentage = (cart.discount_applications || []).find(app =>
          app?.type === 'discount_code' && app.value_type === 'percentage'
        );
        discount = percentage
          ? Math.round(subtotal * dailySavings / dailyOriginal)
          : dailySavings;
      }
    }

    return Math.min(subtotal, Math.max(0, Math.round(discount)));
  }

  function updateTotals(cart = cartState) {
    const subtotal = currentSubtotal();
    const discount = scaledDiscount(subtotal, cart);
    const total = Math.max(0, subtotal - discount);

    const subtotalEl = qs('[data-subtotal]');
    const discountRow = qs('[data-discount-row]');
    const discountAmount = qs('[data-discount-amount]');
    const noVat = qs('[data-total-after-discount]');
    const withVat = qs('[data-total-with-vat]');
    const daysRow = qs('[data-rental-days-row]');
    const daysEl = qs('[data-rental-days]');
    const billedDaysEl = qs('[data-billable-days]');
    const billedDaysRow = qs('[data-billable-days-row]');
    const totalsBox = qs('[data-cart-total-cents]');

    if (subtotalEl) subtotalEl.textContent = money(subtotal);
    if (discountRow) discountRow.hidden = discount <= 0;
    if (discountAmount) discountAmount.textContent = '- ' + money(discount);
    if (noVat) noVat.textContent = money(total);
    if (withVat) withVat.textContent = money(Math.round(total * 1.21));
    const selectedDates = Boolean(qs('[data-rental-start]')?.value && qs('[data-rental-end]')?.value);
    if (daysRow) daysRow.hidden = !selectedDates;
    if (daysEl) daysEl.textContent = String(rentalDays());
    qsa('[data-days-unit]').forEach(el => { el.textContent = rentalDays() === 1 ? 'zi' : 'zile'; });
    qsa('[data-billable-unit]').forEach(el => { el.textContent = billableDays() === 1 ? 'zi' : 'zile'; });
    if (billedDaysEl) billedDaysEl.textContent = String(billableDays());
    if (billedDaysRow) billedDaysRow.hidden = !selectedDates;

    if (totalsBox && cart) {
      totalsBox.dataset.cartTotalCents = String(cart.total_price || 0);
      totalsBox.dataset.cartOriginalTotalCents = String(cart.original_total_price || cart.total_price || 0);
      totalsBox.dataset.cartTotalDiscountCents = String(cart.total_discount || 0);
    }
  }

  function syncDomWithCart(cart) {
    const lines = qsa('[data-cart-line]');
    const items = Array.isArray(cart?.items) ? cart.items : [];

    lines.forEach((line, index) => {
      const item = items[index];
      if (!item) return;

      line.dataset.line = String(index + 1);
      line.dataset.lineKey = String(item.key || '');

      if (Number.isFinite(Number(item.original_price))) {
        line.dataset.unitPrice = String(item.original_price);
      }

      const qty = qs('[data-cart-qty]', line);
      if (qty && document.activeElement !== qty) {
        qty.value = String(item.quantity || 0);
      }
    });
  }

  function renderEmptyCart() {
    const section = qs('.rental-cart-page-v3 > .container');
    if (!section) return;

    // A cart that becomes empty via Ajax must match the initial Liquid
    // empty state: one centered card, one catalog button, no extra link.
    qsa('.rental-cart-layout-v3, [data-cart-empty-state]', section)
      .forEach((element) => element.remove());
    qsa('.rental-cart-head-v3 .cart-continue-v3', section)
      .forEach((element) => element.remove());

    if (!qs('.cart-empty-v3', section)) {
      const empty = document.createElement('div');
      empty.className = 'cart-empty-v3';
      const page = section.closest('.rental-cart-page-v3');
      const zero = document.createElement('span');
      zero.textContent = '0';
      const title = document.createElement('h2');
      title.textContent = page?.dataset.emptyTitle || 'Devizul tău este gol.';
      const description = document.createElement('p');
      description.textContent = page?.dataset.emptyDescription || 'Adaugă echipamente din catalog și revino aici când ești gata.';
      const link = document.createElement('a');
      link.className = 'btn';
      link.href = root + 'collections';
      link.textContent = page?.dataset.emptyButton || 'Deschide catalogul';
      empty.append(zero, title, description, link);
      section.appendChild(empty);
    }
  }

  function applyState(cart) {
    cartState = cart;
    updateBadge(cart?.item_count || 0);
    syncDomWithCart(cart);

    if ((cart?.item_count || 0) === 0) {
      renderEmptyCart();
      return;
    }

    updateTotals(cart);
  }

  function restoreDates(cart) {
    const startInput = qs('[data-rental-start]');
    const endInput = qs('[data-rental-end]');
    if (!startInput || !endInput) return;

    const attrs = cart?.attributes || {};
    const start = startInput.value || readLocal(STORAGE.start) || attrs._rental_start;
    const end = endInput.value || readLocal(STORAGE.end) || attrs._rental_end;

    if (start) startInput.value = start;
    if (end) endInput.value = end;

    writeLocal(STORAGE.start, startInput.value || '');
    writeLocal(STORAGE.end, endInput.value || '');
    endInput.dispatchEvent(new Event('change', { bubbles: true }));
    updateTotals(cart);
  }

  async function persistDates() {
    if (!cartState) cartState = await fetchCart();

    const { start, end } = saveDatesLocal();
    const attributes = {
      ...(cartState.attributes || {}),
      _rental_start: start,
      _rental_end: end
    };

    const cart = await requestCart('cart/update.js', {
      method: 'POST',
      body: JSON.stringify({ attributes })
    });

    applyState(cart);
    return cart;
  }

  async function applyDiscount(code) {
    if (!cartState) cartState = await fetchCart();

    const normalized = String(code || '').trim().toUpperCase();
    const previous = readLocal(STORAGE.discount);
    const { start, end } = saveDatesLocal();
    const input = qs('[data-shopify-discount-input]');
    const message = qs('[data-shopify-discount-message]');

    // Do not mix the discount operation with rental date updates. This makes
    // the discount update independent and avoids stale Ajax cart responses.
    try {
      const datedCart = await requestCart('cart/update.js', {
        method: 'POST',
        body: JSON.stringify({
          attributes: {
            ...(cartState.attributes || {}),
            _rental_start: start,
            _rental_end: end
          }
        })
      });
      cartState = datedCart;
      const result = await requestCart('cart/update.js', {
        method: 'POST',
        body: JSON.stringify({ discount: normalized })
      });
      const cart = await fetchCart().catch(() => result);
      cartState = cart;

      if (!normalized) {
        writeLocal(STORAGE.discount, '');
        applyState(cart);
        if (input) input.value = '';
        if (message) message.textContent = 'Reducerea a fost eliminată.';
        return;
      }

      const codes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
      const codeEntry = codes.find(d => String(d?.code || '').toUpperCase() === normalized);
      const applications = [
        ...(cart.cart_level_discount_applications || []),
        ...(cart.discount_applications || []),
        ...(cart.items || []).flatMap(item =>
          (item.line_level_discount_allocations || []).map(a => a.discount_application))
      ];
      const hasMatchingApplication = applications.some(app =>
        app?.type === 'discount_code' && String(app.title || '').toUpperCase() === normalized
      );
      const accepted = codeEntry?.applicable === true || hasMatchingApplication;
      if (accepted) {
        writeLocal(STORAGE.discount, normalized);
        applyState(cart);
        if (input) input.value = normalized;
        const amount = scaledDiscount(currentSubtotal(), cart);
        if (message) message.textContent = amount > 0
          ? 'Cod aplicat: ' + normalized
          : 'Cod acceptat de Shopify. Reducerea se verifică la trimiterea devizului.';
      } else if (codeEntry?.applicable === false) {
        // Explicit rejection from Shopify: do not promise a discount.
        writeLocal(STORAGE.discount, '');
        applyState(cart);
        if (message) message.textContent = 'Codul ' + normalized + ' nu este aplicabil acestui coș.';
      } else {
        // The Ajax cart sometimes omits checkout-only code details. Preserve
        // the requested code so the Cloudflare Worker can independently check
        // it against Shopify Admin before creating the rental quote.
        writeLocal(STORAGE.discount, normalized);
        applyState(cart);
        if (input) input.value = normalized;
        if (message) message.textContent = 'Cod înregistrat. Shopify va verifica reducerea la trimiterea devizului; totalul afișat este provizoriu.';
      }
    } catch (error) {
      writeLocal(STORAGE.discount, previous);
      if (message) message.textContent = error?.message || 'Nu am putut verifica reducerea.';
      throw error;
    }
  }

  async function changeLine(lineElement, quantity, allowRetry = true) {
    if (!cartState) {
      cartState = await fetchCart();
      syncDomWithCart(cartState);
    }

    let key = lineElement?.dataset.lineKey || '';

    if (!key) {
      const index = qsa('[data-cart-line]').indexOf(lineElement);
      key = String(cartState?.items?.[index]?.key || '');
    }

    if (!key) throw new Error('Produsul nu a putut fi identificat în coș.');

    try {
      const cart = await requestCart('cart/change.js', {
        method: 'POST',
        body: JSON.stringify({
          id: key,
          quantity: Math.max(0, Number(quantity || 0))
        })
      });

      if (Number(quantity) <= 0 && lineElement) lineElement.remove();
      applyState(cart);
      return cart;
    } catch (error) {
      if (!allowRetry) throw error;
      const fresh = await fetchCart();
      cartState = fresh;
      syncDomWithCart(fresh);
      return changeLine(lineElement, quantity, false);
    }
  }

  async function updateQuantity(line, quantity) {
    if (!line) return;

    const input = qs('[data-cart-qty]', line);
    const clean = Math.max(0, Number.parseInt(quantity, 10) || 0);

    if (input) input.value = String(clean);
    updateTotals();

    qsa('button, input', line).forEach((el) => { el.disabled = true; });

    try {
      await changeLine(line, clean);
    } catch (error) {
      if (cartState) { document.activeElement?.blur(); applyState(cartState); }
      throw error;
    } finally {
      if (document.contains(line)) {
        qsa('button, input', line).forEach((el) => { el.disabled = false; });
      }
    }
  }

  async function addProductForm(form) {
    const button = qs('button[type="submit"]', form);
    const originalText = button?.dataset.addText || button?.textContent || 'Adaugă în coș';

    if (button) {
      button.disabled = true;
      button.textContent = 'Se adaugă...';
    }

    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.description || data.message || 'Produsul nu a putut fi adăugat.');
      }

      const cart = await fetchCart();
      cartState = cart;
      updateBadge(cart.item_count || 0);

      if (button) {
        button.textContent = 'Adăugat ✓';
        setTimeout(() => {
          button.disabled = false;
          button.textContent = originalText;
        }, 900);
      }
    } catch (error) {
      console.error('AliB add to cart:', error);
      if (button) {
        button.textContent = 'Încearcă din nou';
        setTimeout(() => {
          button.disabled = false;
          button.textContent = originalText;
        }, 1200);
      }
    }
  }

  function bindEvents() {
    document.addEventListener('submit', (event) => {
      const form = event.target;

      if (form.matches('[data-ajax-cart-add]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        enqueue(() => addProductForm(form)).catch(console.error);
        return;
      }

      if (form.matches('[data-cart-form], [data-shopify-discount-form]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    document.addEventListener('click', (event) => {
      const remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        event.preventDefault();
        event.stopImmediatePropagation();
        saveDatesLocal();
        const line = remove.closest('[data-cart-line]');
        if (!line) return;

        const oldText = remove.textContent;
        remove.disabled = true;
        remove.textContent = 'Se șterge...';

        enqueue(() => changeLine(line, 0))
          .catch((error) => {
            if (document.contains(remove)) {
              remove.disabled = false;
              remove.textContent = oldText;
            }
            console.error(error);
          });
        return;
      }

      const apply = event.target.closest('[data-discount-apply]');
      if (apply) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const input = qs('[data-shopify-discount-input]');
        const oldText = apply.textContent;

        apply.disabled = true;
        apply.textContent = 'Se aplică...';

        enqueue(() => applyDiscount(input?.value || ''))
          .catch((error) => {
            const message = qs('[data-shopify-discount-message]');
            if (message) message.textContent = error.message || 'Codul nu a putut fi aplicat.';
          })
          .finally(() => {
            apply.disabled = false;
            apply.textContent = oldText;
          });
      }
    }, true);

    document.addEventListener('change', (event) => {
      if (event.target.matches('[data-cart-qty]')) {
        const line = event.target.closest('[data-cart-line]');
        enqueue(() => updateQuantity(line, event.target.value)).catch(console.error);
        return;
      }

      if (event.target.matches('[data-rental-start], [data-rental-end]')) {
        saveDatesLocal();
        updateTotals();
        enqueue(persistDates).catch(console.error);
      }
    });

    document.addEventListener('input', (event) => {
      if (event.target.matches('[data-rental-start], [data-rental-end]')) {
        saveDatesLocal();
        updateTotals();
      } else if (event.target.matches('[data-cart-qty]')) {
        updateTotals();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.target.matches('[data-shopify-discount-input]') && event.key === 'Enter') {
        event.preventDefault();
        qs('[data-discount-apply]')?.click();
      }
    });
  }

  async function init() {
    if (initialized) return;
    initialized = true;

    try {
      const cart = await fetchCart();
      cartState = cart;
      restoreDates(cart);
      applyState(cart);

      const nativeCode = (cart.discount_codes || []).find(entry => entry?.applicable === true)?.code ||
        (cart.discount_applications || []).find(app => app?.type === 'discount_code')?.title || '';
      const savedDiscount = readLocal(STORAGE.discount) || String(nativeCode).trim().toUpperCase();
      if (savedDiscount) writeLocal(STORAGE.discount, savedDiscount);
      const discountInput = qs('[data-shopify-discount-input]');
      const discountMessage = qs('[data-shopify-discount-message]');
      if (discountInput && savedDiscount) discountInput.value = savedDiscount;
      if (savedDiscount && discountMessage) {
        discountMessage.textContent = scaledDiscount(currentSubtotal(), cart) > 0
          ? 'Cod aplicat: ' + savedDiscount
          : 'Cod înregistrat. Reducerea va fi verificată la trimiterea devizului.';
      }
    } catch (error) {
      console.error('AliB cart init:', error);
      updateTotals();
    }
  }

  bindEvents();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    fetchCart()
      .then((cart) => {
        cartState = cart;
        restoreDates(cart);
        applyState(cart);
      })
      .catch(() => {});
  });
})();


;
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-phone-only]').forEach((input) => {
    input.addEventListener('input', () => {
      input.value = input.value.replace(/\D/g, '').slice(0, 14);
    });
  });
  document.querySelectorAll('[data-char-count-source]').forEach((textarea) => {
    const counter = textarea.closest('label')?.querySelector('[data-char-count]');
    const update = () => {
      if (textarea.value.length > 1000) textarea.value = textarea.value.slice(0, 1000);
      if (counter) counter.textContent = textarea.value.length;
    };
    textarea.addEventListener('input', update);
    update();
  });
});


;
document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('[data-quote-form]');
  const startInput = document.querySelector('[data-rental-start]');
  const endInput = document.querySelector('[data-rental-end]');
  const submitButton = form?.querySelector('.quote-submit, button[type="submit"]');
  if (!form || !startInput || !endInput || !submitButton) return;

  let error = document.querySelector('[data-required-dates-error]');
  if (!error) {
    error = document.createElement('div');
    error.setAttribute('data-required-dates-error', '');
    error.className = 'required-dates-error';
    error.textContent = 'Te rog completează câmpurile obligatorii.';
    error.hidden = true;
    submitButton.insertAdjacentElement('beforebegin', error);
  }

  function datesComplete() {
    return Boolean(startInput.value && endInput.value);
  }

  function updateSubmitState() {
    const ok = datesComplete();
    submitButton.disabled = !ok;
    submitButton.classList.toggle('is-disabled', !ok);
    if (ok) error.hidden = true;
  }

  [startInput, endInput].forEach((input) => {
    input.addEventListener('input', updateSubmitState);
    input.addEventListener('change', updateSubmitState);
  });

  form.addEventListener('submit', (event) => {
    if (!datesComplete()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      error.hidden = false;
      error.textContent = 'Te rog completează câmpurile obligatorii.';
      error.scrollIntoView({ behavior: 'smooth', block: 'center' });
      updateSubmitState();
    }
  }, true);

  updateSubmitState();
});


;
document.addEventListener('DOMContentLoaded', () => {
  const textarea = document.querySelector('[data-quote-form] textarea[name="contact[body]"]');
  if (!textarea) return;

  textarea.setAttribute('maxlength', '1000');
  textarea.setAttribute('placeholder', '');

  let counter = textarea.parentElement?.querySelector('[data-cart-message-counter]');
  if (!counter) {
    counter = document.createElement('small');
    counter.setAttribute('data-cart-message-counter', '');
    counter.className = 'cart-message-counter';
    textarea.insertAdjacentElement('afterend', counter);
  }

  const updateCounter = () => {
    if (textarea.value.length > 1000) textarea.value = textarea.value.slice(0, 1000);
    counter.textContent = `${textarea.value.length}/1000 caractere`;
  };

  textarea.addEventListener('input', updateCounter);
  updateCounter();
});


;
document.addEventListener('DOMContentLoaded', () => {
  const quoteForm = document.querySelector('[data-quote-form]');
  if (!quoteForm) return;

  const WORKER_URL = 'https://alib-deviz-worker.alin-dobrita.workers.dev/deviz';

  function rentalDays() {
    const start = document.querySelector('[data-rental-start]')?.value || '';
    const end = document.querySelector('[data-rental-end]')?.value || '';
    if (!start || !end) return 1;

    const startDate = new Date(start + 'T00:00:00Z');
    const endDate = new Date(end + 'T00:00:00Z');
    const diff = Math.round((endDate - startDate) / 86400000);

    return Math.max(1, diff);
  }

  function billableDays(days = rentalDays()) {
    const realDays = Math.max(1, Number(days || 1));
    const fullWeeks = Math.floor(realDays / 7);
    const remainder = realDays % 7;
    return Math.max(1, fullWeeks * 5 + remainder);
  }

  function getDiscountCode() {
    return window.AliBCart?.discountCode() || '';
  }

  let submitting = false;
  let turnstileWidget = null;
  const configReady = (async () => {
    try {
      const response = await fetch(WORKER_URL.replace('/deviz', '/public-config'), { cache: 'no-store' });
      const config = await response.json();
      if (!config.turnstile_site_key) return;
      await new Promise((resolve, reject) => {
        if (window.turnstile) return resolve();
        const script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        script.onload = resolve; script.onerror = reject; document.head.appendChild(script);
      });
      const target = document.createElement('div');
      quoteForm.querySelector('button[type="submit"]').before(target);
      turnstileWidget = window.turnstile.render(target, { sitekey: config.turnstile_site_key, action: 'rental_quote' });
    } catch (_) { /* The server remains authoritative if configuration cannot be loaded. */ }
  })();

  function showQuoteMessage(message, isError) {
    let messageBox = document.querySelector('[data-quote-confirmation]');

    if (!messageBox) {
      messageBox = document.createElement('div');
      messageBox.setAttribute('data-quote-confirmation', '');
      quoteForm.prepend(messageBox);
    }

    messageBox.hidden = false;
    messageBox.textContent = message;
    messageBox.style.marginBottom = '14px';
    messageBox.style.padding = '12px 14px';
    messageBox.style.borderRadius = '10px';
    messageBox.style.fontWeight = '700';
    messageBox.style.background = isError ? '#ffe8e8' : '#e8f8ed';
    messageBox.style.color = isError ? '#a40000' : '#12652c';
    messageBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  async function fetchCartItemCount() {
    try {
      const cart = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      }).then((response) => response.json());

      return cart.item_count || 0;
    } catch (error) {
      return null;
    }
  }

  async function clearCartAfterSuccess() {
    for (let attempt = 0; attempt < 2; attempt += 1) {
      try {
        await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          cache: 'no-store',
          credentials: 'same-origin'
        });
      } catch (error) {}

      const itemCount = await fetchCartItemCount();

      if (itemCount === 0) break;
    }

    try {
      await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '', attributes: { _rental_start: '', _rental_end: '' } }) });
    } catch (_) {}
    try {
      ['alib-rental-start', 'alib-rental-end', 'alib-discount-code'].forEach(key => localStorage.removeItem(key));
    } catch (_) {}

    document.querySelectorAll('[data-cart-count], .pana2-cart span').forEach((badge) => {
      badge.textContent = '0';
    });
  }

  quoteForm.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (submitting) return;
    submitting = true;
    // Prevent an unresponsive cart request or blocked anti-spam script from
    // leaving the quote form apparently frozen indefinitely.
    try {
      await Promise.race([
        (async () => { await window.AliBCart?.whenIdle(); await configReady; })(),
        new Promise((_, reject) => setTimeout(() => reject(new Error('Verificarea devizului durează prea mult. Verifică conexiunea și încearcă din nou.')), 15000))
      ]);
    } catch (error) {
      submitting = false;
      showQuoteMessage(error?.message || 'Nu am putut pregăti devizul. Încearcă din nou.', true);
      return;
    }

    const submitButton = quoteForm.querySelector('button[type="submit"]');
    const originalButtonText = submitButton?.textContent || 'Trimite';

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Se trimite...';
    }

    const enteredCode = document.querySelector('[data-shopify-discount-input]')?.value.trim().toUpperCase() || '';
    if (enteredCode !== getDiscountCode()) {
      showQuoteMessage('Apasă Aplică pentru a confirma sau elimina codul de reducere.', true);
      submitting = false;
      if (submitButton) { submitButton.disabled = false; submitButton.textContent = originalButtonText; }
      return;
    }
    const days = rentalDays();
    const billedDays = billableDays(days);
    // Read real Shopify cart items, not potentially stale DOM data attributes.
    const products = [];
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
        credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Nu am putut verifica produsele din coș.');
      const shopifyCart = await response.json();
      for (const item of (shopifyCart.items || [])) {
        const variantId = String(item.variant_id || item.id || '').trim();
        if (!variantId || ![...variantId].every(c => c >= '0' && c <= '9') || Number(item.quantity) < 1) {
          throw new Error('ID-ul unui produs din coș este invalid. Reîncarcă pagina și încearcă din nou.');
        }
        products.push({
          variant_id: variantId,
          title: item.product_title || item.title || '',
          image: item.image || '',
          quantity: Number(item.quantity),
          price_per_day: Number(item.original_price || item.price || 0) / 100
        });
      }
    } catch (cartError) {
      showQuoteMessage(cartError?.message || 'Nu am putut verifica devizul.', true);
      submitting = false;
      if (submitButton) { submitButton.disabled = false; submitButton.textContent = originalButtonText; }
      return;
    }

    if (!products.length) {
      submitting = false;
      showQuoteMessage('Coșul este gol.', true);
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;
      }
      return;
    }

    const subtotal = products.reduce(
      (sum, product) =>
        sum + product.price_per_day * product.quantity * billedDays,
      0
    );

    // The Worker recalculates final amounts in Shopify. Keep the client payload
    // aligned with the displayed cart estimate, including an applied discount.
    const estimatedDiscount = Math.min(subtotal, Math.max(0, Number(window.AliBCart?.quoteTotals()?.discountCents || 0) / 100));
    const totalWithoutVat = Math.max(0, subtotal - estimatedDiscount);
    const vat = totalWithoutVat * 0.21;
    const total = totalWithoutVat + vat;
    const discountCode = getDiscountCode();

    const payload = {
      turnstile_token: turnstileWidget !== null ? window.turnstile.getResponse(turnstileWidget) : '',
      name:
        quoteForm.querySelector('[name="contact[name]"]')?.value || '',
      email:
        quoteForm.querySelector('[name="contact[email]"]')?.value || '',
      phone:
        quoteForm.querySelector('[name="contact[Telefon]"]')?.value || '',
      cui:
        quoteForm.querySelector('[name="contact[CUI firma]"]')?.value || '',
      message:
        quoteForm.querySelector('[name="contact[body]"]')?.value || '',
      website:
        quoteForm.querySelector('[name="contact[website]"]')?.value || '',
      terms_accepted: Boolean(quoteForm.querySelector('[name="terms_accepted"]')?.checked),
      terms_version: '2026-10-12',
      rental_start:
        document.querySelector('[data-rental-start]')?.value || '',
      rental_end:
        document.querySelector('[data-rental-end]')?.value || '',
      rental_days: days,
      billable_days: billedDays,
      products,
      discount_code: discountCode,
      currency: 'EUR',
      total_without_vat: totalWithoutVat.toFixed(2),
      vat: vat.toFixed(2),
      total_with_vat: total.toFixed(2)
    };

    try {
      const response = await fetch(WORKER_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok || !result.success) {
        throw new Error(
          result.error ||
          `Devizul nu a fost trimis. Eroare HTTP ${response.status}.`
        );
      }

      showQuoteMessage('Deviz trimis cu succes.', false);
      await clearCartAfterSuccess();
      window.location.href = '/pages/deviz-trimis';
    } catch (error) {
      submitting = false;
      if (turnstileWidget !== null) window.turnstile.reset(turnstileWidget);
      console.error('Worker error:', error);
      showQuoteMessage(
        error?.message || 'Devizul nu a putut fi trimis.',
        true
      );

      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;
      }
    }
  });
});


;
(() => {
  const qs=(s,p=document)=>p.querySelector(s);
  const qsa=(s,p=document)=>Array.from(p.querySelectorAll(s));

  function todayLocal(){
    const d=new Date();
    const y=d.getFullYear();
    const m=String(d.getMonth()+1).padStart(2,'0');
    const day=String(d.getDate()).padStart(2,'0');
    return y+'-'+m+'-'+day;
  }

  function clearStoredDate(key){
    try{ localStorage.removeItem(key); }catch(_){}
  }

  function ensureDateMessage(){
    const box=qs('.rental-period-box, .rental-period-v3');
    if(!box) return null;
    let msg=qs('[data-rental-date-error]',box);
    if(!msg){
      msg=document.createElement('div');
      msg.setAttribute('data-rental-date-error','');
      msg.className='rental-date-error-v10';
      msg.hidden=true;
      box.appendChild(msg);
    }
    return msg;
  }

  function validateRentalDates(showMessage=false){
    const start=qs('[data-rental-start]');
    const end=qs('[data-rental-end]');
    if(!start||!end) return true;

    const today=todayLocal();
    start.min=today;

    if(start.value && start.value<today){
      start.value='';
      clearStoredDate('alib-rental-start');
    }

    end.disabled=!start.value;
    end.min=start.value || today;

    if(end.value && end.value<end.min){
      end.value='';
      clearStoredDate('alib-rental-end');
    }

    const msg=ensureDateMessage();
    let error='';
    if(showMessage){
      if(!start.value) error='Alege mai întâi data de preluare.';
      else if(!end.value) error='Alege data de predare. Aceasta nu poate fi înaintea datei de preluare.';
    }

    start.setCustomValidity('');
    end.setCustomValidity(error && start.value ? error : '');
    if(msg){
      msg.textContent=error;
      msg.hidden=!error;
    }
    return !error;
  }

  document.addEventListener('change',e=>{
    if(e.target.matches('[data-rental-start]')){
      validateRentalDates(false);
      const end=qs('[data-rental-end]');
      if(end && !end.disabled) end.focus();
    } else if(e.target.matches('[data-rental-end]')){
      validateRentalDates(true);
    }
  },true);

  document.addEventListener('input',e=>{
    if(e.target.matches('[data-rental-start], [data-rental-end]')) validateRentalDates(false);
  },true);

  document.addEventListener('submit',e=>{
    const form=e.target.closest('[data-quote-form]');
    if(!form) return;
    if(!validateRentalDates(true)){
      e.preventDefault();
      e.stopImmediatePropagation();
      qs('[data-rental-start]')?.scrollIntoView({behavior:'smooth',block:'center'});
    }
  },true);

  function init(){ validateRentalDates(false); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  window.addEventListener('pageshow',()=>validateRentalDates(false));
})();

;
(() => {
 const qs=(s,p=document)=>p.querySelector(s);
 const qsa=(s,p=document)=>Array.from(p.querySelectorAll(s));
 const localDate=()=>{const d=new Date();return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0')};
 const billable=d=>{d=Math.max(1,Number(d||1));return Math.max(1,Math.floor(d/7)*5+(d%7))};
 const money=c=>((Number(c||0)/100).toLocaleString('ro-RO',{minimumFractionDigits:2,maximumFractionDigits:2})+' €');

 function initProductEstimator(){
   const box=qs('[data-product-rental-estimator]'); if(!box)return;
   const start=qs('[data-product-rental-start]',box), end=qs('[data-product-rental-end]',box);
   const total=qs('[data-product-rental-total]',box), meta=qs('[data-product-rental-days]',box);
   const unit=Number(box.dataset.unitPriceCents||0);
   const today=localDate(); start.min=today;
   try{
     const savedStart=localStorage.getItem('alib-rental-start')||'';
     const savedEnd=localStorage.getItem('alib-rental-end')||'';
     if(savedStart>=today) start.value=savedStart;
     if(start.value){end.disabled=false;end.min=start.value;if(savedEnd>=start.value)end.value=savedEnd}
   }catch(_){}
   const update=()=>{
     start.min=today;
     if(start.value && start.value<today)start.value='';
     end.disabled=!start.value; end.min=start.value||today;
     if(end.value && end.value<end.min)end.value='';
     if(!start.value||!end.value){total.textContent='—';meta.textContent='Disponibilitatea se confirmă după trimiterea devizului.';return}
     const a=new Date(start.value+'T00:00:00Z'),b=new Date(end.value+'T00:00:00Z');
     const days=Math.max(1,Math.round((b-a)/86400000)); const billed=billable(days);
     total.textContent=money(unit*billed);
     meta.textContent=days+(days===1?' zi calendaristică · ':' zile calendaristice · ')+billed+(billed===1?' zi facturată':' zile facturate')+' · disponibilitatea se confirmă separat.';
     try{localStorage.setItem('alib-rental-start',start.value);localStorage.setItem('alib-rental-end',end.value)}catch(_){}
   };
   start.addEventListener('change',()=>{update();if(start.value)end.focus()});end.addEventListener('change',update);update();
 }

 function initCollectionTools(){
   const grid=qs('.collection-product-grid-v3'); if(!grid)return;
   const cards=qsa('[data-product-card]',grid); if(!cards.length)return;
   const search=qs('[data-collection-search]'), vendor=qs('[data-collection-vendor]'), sort=qs('[data-collection-sort]');
   const empty=qs('[data-collection-no-results]');
   const original=[...cards];
   const refresh=()=>{
     const term=(search?.value||'').trim().toLowerCase(), v=(vendor?.value||'').toLowerCase();
     let visible=cards.filter(card=>{
       const okTitle=!term||(card.dataset.productTitle||'').toLowerCase().includes(term);
       const okVendor=!v||(card.dataset.productVendor||'').toLowerCase()===v;
       card.hidden=!(okTitle&&okVendor); return !card.hidden;
     });
     const mode=sort?.value||'default';
     if(mode!=='default'){
       visible.sort((a,b)=>{
         if(mode==='price-asc')return Number(a.dataset.productPrice||0)-Number(b.dataset.productPrice||0);
         if(mode==='price-desc')return Number(b.dataset.productPrice||0)-Number(a.dataset.productPrice||0);
         return (a.dataset.productTitle||'').localeCompare(b.dataset.productTitle||'','ro');
       });
       visible.forEach(card=>grid.appendChild(card));
     }else{
       original.forEach(card=>grid.appendChild(card));
     }
     if(empty)empty.hidden=visible.length!==0;
   };
   search?.addEventListener('input',refresh);vendor?.addEventListener('change',refresh);sort?.addEventListener('change',refresh);
 }

 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{initProductEstimator();initCollectionTools()},{once:true});
 else{initProductEstimator();initCollectionTools()}
})();
